<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs12>
                <h2 class="heading">Symptoms</h2>
                <p class="signup-subheading">pick a symptom</p>
            </v-flex>
            <v-flex xs12 d-flex pa-0>
                <v-list>
                    <template v-for="(item, i) in symptom.availableSymptoms">
                        <v-divider v-if="i > 0"/>
                        <v-list-tile :key="item.Name" @click="select(item)">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.Name"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState} from 'vuex'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapState(
                ['symptom']
            )
        },
        methods: {
            select(item) {
                EventBus.$emit('symptom-symptom-selected', item);
            }
        },
        created() {
        },
        mounted() {
            Loading.hide()
        }
    }
</script>